import prismicDOM from 'prismic-dom'

export const PrismicText = {
  install(Vue) {
    Vue.prototype.$prismicHtml = function(value) {
      if (!value) return ''
      return prismicDOM.RichText.asHtml(value)
    }
    Vue.prototype.$prismicText = function(value) {
      if (!value) return ''
      return prismicDOM.RichText.asText(value)
    }
    Vue.prototype.$prismicHasText = function(value) {
      if (!value) return false
      return !!prismicDOM.RichText.asText(value).trim()
    }
  }
}
